import { fillPreset, assertPresetCompiles } from './materialPresetFill.js'

// The Fresnel rim seed a bare "Graph" starts from: something visible at once,
// with one exposed parameter so the inspector is not empty.
export const SEED_GRAPH = {
  version: 1,
  nodes: [
    { id: 'out', type: 'PrincipledBSDF', data: {}, position: { x: 420, y: 160 } },
    { id: 'fr',  type: 'Fresnel', data: { exponent: 3, f0: 0.04, expose: { exponent: 'Rim Power' } }, position: { x: 120, y: 160 } },
  ],
  edges: [{ id: 'e1', source: 'fr', sourceHandle: 'out', target: 'out', targetHandle: 'emissive' }],
}

const KIND_TO_PRESET = { 'material-pbr': 'pbr' }
const KIND_TO_NAME = { 'material-pbr': 'New PBR Material', 'material-graph': 'New Graph Material' }

export function isMaterialKind(kind) {
  return kind in KIND_TO_NAME
}

// Every material is a graph. PBR is the server's preset filled with nothing
// (every slot empty = identity, Task 1); Graph is the local seed.
//
// TOON IS GONE, and the server still serves its preset. That asymmetry is
// deliberate rather than an oversight: the preset is a row in another service's
// response and removing it is that service's change, while what THIS repo
// decides is what it offers. A `material-toon` kind now fails `isMaterialKind`
// like any other unknown string, so the menu cannot mint one.
export function buildMaterialCreateBody(kind, presets, { folderPath = '/materials' } = {}) {
  if (!isMaterialKind(kind)) throw new Error(`"${kind}" is not a material kind`)
  let graph
  if (kind === 'material-graph') {
    graph = SEED_GRAPH
  } else {
    const preset = KIND_TO_PRESET[kind]
    const template = presets?.[preset]
    if (!template) throw new Error(`material preset "${preset}" was not served by the asset manager`)
    assertPresetCompiles(template)
    graph = fillPreset(template, {})
  }
  return { name: KIND_TO_NAME[kind], type: 'graph', folderPath, data: { graph } }
}
